/* @flow */
import Entity from 'lib/Entity';

export type MessageDeliverySummaryUserType = {
  id: Backbone$Id,
  uuid: string,
  name: string,
  color: ?string,
  initials: ?string,
};

export default class MessageDeliverySummary extends Entity {
  initialize() {
    this.idAttribute = 'message_uuid';
  }

  getMessageType(): string {
    return this.get('message_type');
  }

  getState(): ?LegacyMessageDeliveryStatusType {
    return this.get('state');
  }

  setState(state: LegacyMessageDeliveryStatusType) {
    this.set('state', state);
  }

  getSuccessCount(): number {
    return this.get('success_count') || 0;
  }

  getReadCount(): number {
    return this.get('read_count') || 0;
  }

  getFailedCount(): number {
    return this.get('failed_count') || 0;
  }

  getTotalSent(): number {
    return this.getSuccessCount() + this.getReadCount() + this.getFailedCount();
  }

  getSteamUUID(): string {
    return this.get('stream_uuid');
  }

  getSuccessUsers(): MessageDeliverySummaryUserType[] {
    return this.get('success_users') || [];
  }

  getReadUsers(): MessageDeliverySummaryUserType[] {
    return this.get('read_users') || [];
  }

  getFailedUsers(): MessageDeliverySummaryUserType[] {
    return this.get('failed_users') || [];
  }
}
